export enum NursingManagementLink {
    NursingSupervisor = '/pages/nurseSupervisor/main',
    NursingTimeline = '/pages/nurseTimeline/main',
    PatientTimeline = '/pages/patientTimeline/main',
    NursingWorklist = '/pages/nursingWorklist/main',
}
